import axios from "axios";
import { Base_URL } from "../url";

export const saveVendorInvoice = async (invoiceData) => {
  console.log(invoiceData);
  try {
    const response = await axios.post(`${Base_URL}/Invoices/InvoicesInserData`, invoiceData, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save vendor invoice";
  }
};

export const fetchProjects = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ProjectMaster/GetAllProjects`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch projects";
  }
};

export const fetchItems = async () => {
  try {
    const response = await axios.get(`${Base_URL}/Item/ItemGetData`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch items";
  }
};